<template>
    <div class="home">
          <div class="box">	
              <form @submit.prevent="saveNote">
                      <div class="field">
                          <label class="label">Note Text </label>
                          <div class="control">
                              <textarea class="textarea" rows="5" v-model="text" required></textarea>
                             
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Expiry Date (end of this day)</label>
                          <div class="control">
                              <input class="input" type="date" v-model="expiry_date" required>
                          </div>
                      </div>

                     
                     
                      <div class="field is-grouped">
                          <div class="control">
                              <button class="button is-success" :disabled="working===true">Save Note</button>
                          </div>
                      </div>
                  </form>
            
          </div>
          
      </div>
  </template>

<script>
    //import AwardsMixin from '@/mixins/AwardsMixin.js';
    import NoteService from '@/services/NoteService.js';
    //import UtilityService from '@/services/UtilityService.js';
    
    export default {
      name: 'AddNote',
        mixins: [],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    accessToken: '',
                    text: '',
                    expiry_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                    working: false
                    
                   
            }
        },
        created() {
          this.getAccessToken()
            .then(() => { 
              
            });
          
        },
        methods: {
            
            async saveNote() {
                this.working = true
                var formdata = { 
                    text : this.text,
                    expiry_date : this.expiry_date
                }; 

                NoteService.saveNote(this.accessToken, formdata)
                .then( (response) => {
                    
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                })
                .finally(() => {
                    
                    this.$router.push("/notes");
                })
            },
           
        }
    }
    </script>